import * as React from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import DeleteOneDocumentModal from 'modules/documents/components/BulkDeleteDocuments/DeleteOneDocumentModal'
import getTitle from 'modules/documents/components/Documents/getTitle'
import { Document } from 'modules/documents/hooks/documents/useGetDocuments'
import { Folder } from 'modules/documents/hooks/useGetFolders'

interface Props {
  document: Document
  folder?: Folder
  rootParentFolder?: Folder
  onDelete: (documentIds: number[]) => void
}

const TitleHeader = ({ document, folder, rootParentFolder, onDelete }: Props) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false)
  const rootFolderPath = folder?.parentFolder?.id === rootParentFolder?.id ? '/' : '/.../'

  return (
    <Box flexDirection="row" gap="s8" justifyContent="spaceBetween">
      <Box flexDirection="column" padding="s16" height="s64" justifyContent="center">
        <Box flexDirection="row" gap="s8">
          <Text.Normal size="200" weight="medium" color="grey1000" ellipsis>
            {document.filename}
          </Text.Normal>
        </Box>
        {folder?.name && (
          <Box flexDirection="row" gap="s8">
            <Text.Normal size="100" color="grey1000">
              {i18n.t('split_documents.assign_documents.destination_folder')}:
            </Text.Normal>
            <Box flexDirection="row">
              {rootParentFolder?.name && (
                <Text.Normal size="100" color="grey1000">
                  {getTitle(rootParentFolder.name)}
                  {rootFolderPath}
                </Text.Normal>
              )}
              <Text.Normal size="100" color="grey1000">
                {getTitle(folder.name)}
              </Text.Normal>
            </Box>
          </Box>
        )}
        {isModalOpen && (
          <DeleteOneDocumentModal
            document={document}
            onClose={() => setIsModalOpen(false)}
            onDelete={onDelete}
          />
        )}
      </Box>
      <Box
        flexDirection="row"
        gap="s8"
        padding="s16"
        height="s64"
        justifyContent="center"
        paddingLeft="s8"
      >
        <Button onClick={() => setIsModalOpen(true)} type="secondary" iconName="delete" />
      </Box>
    </Box>
  )
}

export default TitleHeader
